import type { OrganisationBranding } from '@empower-safety/shared-types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApi } from './client.js';

export interface OrganisationDto {
  id: string;
  clerk_org_id: string;
  type: 'customer' | 'partner' | 'platform';
  name: string;
  slug: string;
  plan: 'trial' | 'team' | 'business' | 'enterprise';
  billing_status: 'trialing' | 'active' | 'past_due' | 'cancelled' | 'paused';
  seat_limit: number | null;
  timezone: string;
  sso_enabled: boolean;
  branding: OrganisationBranding;
  offline_policy: Record<string, unknown>;
  active: boolean;
}

export function useCurrentOrganisation() {
  const api = useApi();
  return useQuery({
    queryKey: ['organisation', 'current'],
    queryFn: () => api<OrganisationDto>('/organisations/current'),
    staleTime: 5 * 60_000,
  });
}

export interface PatchOrgInput {
  name?: string;
  timezone?: string;
  branding?: OrganisationBranding;
  offline_policy?: Record<string, unknown>;
}

export function usePatchOrganisation() {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: PatchOrgInput) =>
      api<OrganisationDto>('/organisations/current', {
        method: 'PATCH',
        body: JSON.stringify(input),
      }),
    onSuccess: (next) => {
      qc.setQueryData(['organisation', 'current'], next);
    },
  });
}
